import Polyglot from 'node-polyglot';
import ru from '../lang/ru.json';
import en from '../lang/en.json';
import uk from '../lang/uk.json';
import de from '../lang/de.json';
import es from '../lang/es.json';
import fr from '../lang/fr.json';
import pl from '../lang/pl.json';
import tr from '../lang/tr.json';
import pt from '../lang/pt.json';
import ro from '../lang/ro.json';
import el from '../lang/el.json';
import cs from '../lang/cs.json';
import it from '../lang/it.json';
import hu from '../lang/hu.json';

const messages = { ru, en, uk, de, es, fr, pl, tr, pt, ro, el, cs, it, hu };
export const locale = document.documentElement.lang || 'ru';

const polyglot = new Polyglot({
    phrases: messages[locale] || messages.ru,
    locale,
    onMissingKey: (key) => key
});

/**
 * Translate a key
 * @param {string} key - Translation key (same as in Laravel __())
 * @param {Object} [options] - Interpolation options
 * @returns {string}
 *
 * @example
 * t('Выберите роль')
 * t('Привет, %{name}!', { name: 'Игрок' })
 * t('%{smart_count} игрок |||| %{smart_count} игрока |||| %{smart_count} игроков', { smart_count: 5 })
 */
export function t(key, options) {
    return polyglot.t(key, options);
}
